/** Limit number of item when call get list API */
export const API_LIMIT = 10 as const

/** Default page number when call get list API */
export const API_DEFAULT_PAGE = 1 as const
